import {useIntl} from 'react-intl';
import React from 'react';
import {
  Checkbox,
  Input,
  Button
} from 'semantic-ui-react'

const MuscleTMJExam = (props: any) => {
    const intl = useIntl();
    const isMounted = React.useRef(true);

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{ width: "100%", height: "100%", padding: "5px" }}>
        <div
          style={{ padding: "5px",  backgroundColor: "#2D9CDB", color: "white", fontWeight: "bold", fontSize: "1.5em"}}>
          {intl.formatMessage({id: "cukey125"})}
        </div>
        <div
          style={{ padding: "10px", display: "grid", gridTemplateColumns: "25% 25% 50%", gridTemplateRows: "repeat(3, 1fr)" }}>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{ marginRight: "10px", fontWeight:"bold" }}>
              {intl.formatMessage({id: "cukey127"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "planeScale1", value: value, text: value, input: true } })}
              value={props.muscleExamData?.planeScale1?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey104"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px", width:"45em" }}>
            <Checkbox
              checked={props.muscleExamData?.jointSound1?.value}
              label="No"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "jointSound1", value: checked,text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Checkbox
              checked={props.muscleExamData?.jointSound2?.value}
              label="Yes"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "jointSound2", value: checked, text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "jointSound3", value: value, text: value, input: true } })}
              style={{width:"100%"}}
              value={props.muscleExamData?.jointSound3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{ marginRight: "10px", fontWeight:"bold" }}>
              {intl.formatMessage({id: "cukey123"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px", width:"45em" }}>
            
            <Checkbox
              checked={props.muscleExamData?.mouthOpening1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "mouthOpening1", value: checked , text:label } })}
              style={ {  marginRight: "10px", width:"230px" } }>
            </Checkbox>
            <Checkbox
              checked={props.muscleExamData?.mouthOpening2?.value}
              label="limit (<40 mm)"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "mouthOpening2", value: checked, text:label  } })}
              style={ {  marginRight: "10px", width:"300px" } }>
            </Checkbox>
            <Checkbox
              checked={props.muscleExamData?.mouthOpening3?.value}
              label="Other"
              onChange={(e, { checked,label}) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "mouthOpening3", value: checked, text:label  } })}
              style={ {  marginRight: "10px", width:"150px" } }>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedMuscleExam", params: { name: "mouthOpening4", value: value, text: value, input: true } })}
              style={{width:"100%"}}
              value={props.muscleExamData?.mouthOpening4?.value}>
            </Input>
          </div>
        </div>
        <div
          style={{display:"flex", justifyContent:"center"}}>
          
          <Button
            color="green"
            onClick={props.handleSaveMuscleExam}
            style={{margin: "5px 0"}}>
            {intl.formatMessage({id: "cukey187"})}
          </Button>
        </div>
      </div>
    )
}

export default MuscleTMJExam

export const screenPropsDefault = {}

/* Date Time : Fri May 14 2021 06:16:36 GMT+0000 (Coordinated Universal Time)
/* Original screen Data **************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"5px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey125"})}
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\",  backgroundColor: \"#2D9CDB\", color: \"white\", fontWeight: \"bold\", fontSize: \"1.5em\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", display: \"grid\", gridTemplateColumns: \"25% 25% 50%\", gridTemplateRows: \"repeat(3, 1fr)\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\", width:\"45em\" }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.muscleExamData?.jointSound1?.value"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"jointSound1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey127"})}
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey104"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Input",
      "parent": 5,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"planeScale1\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.muscleExamData?.planeScale1?.value"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", justifyContent:\"center\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey187"})}
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleSaveMuscleExam"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 0\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.muscleExamData?.jointSound2?.value"
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"jointSound2\", value: checked, text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "label",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey123"})}
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\", width:\"45em\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Checkbox",
      "parent": 94,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.muscleExamData?.mouthOpening1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"mouthOpening1\", value: checked , text:label } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"230px\" } "
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "Checkbox",
      "parent": 94,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.muscleExamData?.mouthOpening2?.value"
        },
        "label": {
          "type": "value",
          "value": "limit (<40 mm)"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"mouthOpening2\", value: checked, text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"300px\" } "
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Checkbox",
      "parent": 94,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.muscleExamData?.mouthOpening3?.value"
        },
        "label": {
          "type": "value",
          "value": "Other"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked,label}) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"mouthOpening3\", value: checked, text:label  } })"
        },
        "style": {
          "type": "code",
          "value": " {  marginRight: \"10px\", width:\"150px\" } "
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Input",
      "parent": 94,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"mouthOpening4\", value: value, input: true } })"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.muscleExamData?.mouthOpening4?.value"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Input",
      "parent": 8,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedMuscleExam\", params: { name: \"jointSound3\", value: value, input: true } })"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.muscleExamData?.jointSound3?.value"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 92,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": true,
  "memo": false,
  "name": "MuscleTMJExam",
  "project": "cudent",
  "screenPropsDefault": {
  },
  "width": 55
}

************************************************************************************* */
